var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TICK_NOT_TICKED",
    "data-name": "TICK NOT TICKED",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#34C759"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M5.373,7.733l-3.092-3.4A1.286,1.286,0,0,0,.41,4.287a1.42,1.42,0,0,0-.043,1.95l4.005,4.354A1.24,1.24,0,0,0,5.287,11a1.19,1.19,0,0,0,.913-.363l8.4-8.3a1.4,1.4,0,0,0,.043-1.9A1.229,1.229,0,0,0,12.819.386Z",
    transform: "translate(8 9)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckIc);
export default __webpack_public_path__ + "static/media/green-check-ic.cb7fc2a549b3b1cb135ad357552e9261.svg";
export { ForwardRef as ReactComponent };